"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeffyLandingPageUrl = exports.getZeffyDonateToNonprofitsLink = exports.getZeffyDemoLink = exports.getZeffyContactLink = exports.getZeffyMarketingBaseUrl = exports.getVerificationHelpArticleUrl = exports.helpCenterLinkForCountry = exports.TermsAndConditionsUrl = exports.VisitorMonthlyReportLetUsKnowUrl = exports.VisitorWeeklyReportLetUsKnowUrl = exports.TaxReceiptDonorFaqUrl = exports.ReferralUrl = exports.ETicketEventDetailsUrl = exports.ETicketMembershipDetailsUrl = exports.ETicketLotteryDetailsUrl = exports.ETicketLotteryUrl = exports.ETicketKnowMoreUrl = exports.ZeffyHelpUrl = exports.Sms2faSupportedCountriesUrl = exports.FundDesignationGuideUrl = exports.DonateButtonGuideUrl = exports.PopupEmbedGuideUrl = exports.LeaderboardEmbedGuideUrl = exports.ThermometerEmbedGuideUrl = exports.EmbedFormGuideUrl = exports.HomePageFreePlatformUrl = void 0;
const country_1 = require("../enums/country");
const locales_1 = require("../enums/locales");
exports.HomePageFreePlatformUrl = {
    [locales_1.Locales.EN]: "https://www.zeffy.com/home/100-free-for-donors",
    [locales_1.Locales.FR]: "https://fr.zeffy.com/home/100-free-for-donors",
    [locales_1.Locales.ES]: "https://www.zeffy.com/home/100-free-for-donors",
    [locales_1.Locales.DE]: "https://www.zeffy.com/de-de/home/100-free-for-donors",
};
exports.EmbedFormGuideUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#embed",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#integrer",
    [locales_1.Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#embed",
    [locales_1.Locales.DE]: "https://support.zeffy.com/de/ihre-zeffy-kampagne-mit-ihren-unterstutzern-und-ihrer-community-teilen-k5z1c",
};
exports.ThermometerEmbedGuideUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#thermometer",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#thermometre",
    [locales_1.Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#thermometer",
    [locales_1.Locales.DE]: "https://support.zeffy.com/de/ihre-peer-to-peer-kampagne-ihr-thermometer-oder-ihre-rangliste-einbetten-fkk09",
};
exports.LeaderboardEmbedGuideUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#leaderboard",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#leaderboard",
    [locales_1.Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#leaderboard",
    [locales_1.Locales.DE]: "https://support.zeffy.com/de/ihre-peer-to-peer-kampagne-ihr-thermometer-oder-ihre-rangliste-einbetten-fkk09",
};
exports.PopupEmbedGuideUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/how-do-i-share-my-form#pop-up",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/comment-puis-je-partager-mon-formulaire#pop-up",
    [locales_1.Locales.ES]: "https://support.zeffy.com/how-do-i-share-my-form#pop-up",
    // No German pop-up-specific article — the general campaign sharing guide is the closest match.
    [locales_1.Locales.DE]: "https://support.zeffy.com/de/ihre-zeffy-kampagne-mit-ihren-unterstutzern-und-ihrer-community-teilen-k5z1c",
};
exports.DonateButtonGuideUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/add-a-donate-button-to-a-website",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/ajouter-un-bouton-%C3%A0-un-site-web-pour-partager-votre-formulaire",
    [locales_1.Locales.ES]: "https://support.zeffy.com/add-a-donate-button-to-a-website",
    [locales_1.Locales.DE]: "https://support.zeffy.com/de/add-a-button-to-a-website-to-share-your-campaign-dyh1i",
};
exports.FundDesignationGuideUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/add-fund-selection-to-your-donation-form",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/proposer-la-selection-de-fonds-aux-donateurs-cn0b8",
    [locales_1.Locales.ES]: "https://support.zeffy.com/add-fund-selection-to-your-donation-form",
    [locales_1.Locales.DE]: "https://support.zeffy.com/de/verwenden-sie-die-fondszuordnung-um-spenden-zu-kategorisieren-und-spendern-die-auswahl-eines-fonds-zu-ermoglichen-cn0b8",
};
exports.Sms2faSupportedCountriesUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/countries-supported-for-sms-two-factor-authentication-2fa",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/pays-o%C3%B9-lauthentification-%C3%A0-deux-facteurs-2fa-par-sms-est-disponible-",
    [locales_1.Locales.ES]: "https://support.zeffy.com/countries-supported-for-sms-two-factor-authentication-2fa",
    [locales_1.Locales.DE]: "https://support.zeffy.com/countries-supported-for-sms-two-factor-authentication-2fa",
};
exports.ZeffyHelpUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/getting-started-with-zeffy",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/getting-started-with-zeffy-ooulc",
    [locales_1.Locales.ES]: "https://support.zeffy.com/getting-started-with-zeffy",
    [locales_1.Locales.DE]: "https://support.zeffy.com/getting-started-with-zeffy",
};
exports.ETicketKnowMoreUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/checking-in-guests-the-day-of-your-event",
    [locales_1.Locales.ES]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [locales_1.Locales.DE]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
};
exports.ETicketLotteryUrl = {
    [locales_1.Locales.EN]: "https://www.zeffy.com/blog/create-successful-raffles-and-lotteries",
    [locales_1.Locales.FR]: "https://fr.zeffy.com/blog/create-successful-raffles-and-lotteries",
    [locales_1.Locales.ES]: "https://www.zeffy.com/blog/create-successful-raffles-and-lotteries",
    [locales_1.Locales.DE]: "https://www.zeffy.com/blog/create-successful-raffles-and-lotteries",
};
exports.ETicketLotteryDetailsUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/does-zeffy-draw-a-raffle-winner",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/est-ce-que-zeffy-tire-au-sort-un-gagnant-pour-ma-loterie",
    [locales_1.Locales.ES]: "https://support.zeffy.com/does-zeffy-draw-a-raffle-winner",
    [locales_1.Locales.DE]: "https://support.zeffy.com/does-zeffy-draw-a-raffle-winner",
};
exports.ETicketMembershipDetailsUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/generating-membership-cards",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/g%C3%A9n%C3%A9rer-une-carte-de-membre-pour-les-adh%C3%A9sions",
    [locales_1.Locales.ES]: "https://support.zeffy.com/generating-membership-cards",
    [locales_1.Locales.DE]: "https://support.zeffy.com/generating-membership-cards",
};
exports.ETicketEventDetailsUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/checking-in-guests-the-day-of-your-event",
    [locales_1.Locales.ES]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
    [locales_1.Locales.DE]: "https://support.zeffy.com/checking-in-guests-the-day-of-your-event",
};
exports.ReferralUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/zeffy-referral-terms",
    [locales_1.Locales.FR]: "https://support.zeffy.com/zeffy-referral-terms",
    [locales_1.Locales.ES]: "https://support.zeffy.com/zeffy-referral-terms",
    [locales_1.Locales.DE]: "https://support.zeffy.com/zeffy-referral-terms",
};
exports.TaxReceiptDonorFaqUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/tax-season-donor-faq",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/tax-season-donor-faq",
    [locales_1.Locales.ES]: "https://support.zeffy.com/fr-ca/tax-season-donor-faq",
    [locales_1.Locales.DE]: "https://support.zeffy.com/tax-season-donor-faq",
};
exports.VisitorWeeklyReportLetUsKnowUrl = {
    [locales_1.Locales.EN]: "https://share.hsforms.com/1LThgiL0_T7mhVsQ8EOBcjQ1k13p",
    [locales_1.Locales.FR]: "https://share.hsforms.com/1ZTGfNnXLQuulEtHO5zwHNg1k13p",
    [locales_1.Locales.ES]: "https://share.hsforms.com/1LThgiL0_T7mhVsQ8EOBcjQ1k13p",
    [locales_1.Locales.DE]: "https://share.hsforms.com/1LThgiL0_T7mhVsQ8EOBcjQ1k13p",
};
exports.VisitorMonthlyReportLetUsKnowUrl = {
    [locales_1.Locales.EN]: "https://share.hsforms.com/1iHSn9qGGSjeuznl-FWsHQQ1k13p",
    [locales_1.Locales.FR]: "https://share.hsforms.com/1i-_izDSuSYin7y_yQZmIGg1k13p",
    [locales_1.Locales.ES]: "https://share.hsforms.com/1iHSn9qGGSjeuznl-FWsHQQ1k13p",
    [locales_1.Locales.DE]: "https://share.hsforms.com/1iHSn9qGGSjeuznl-FWsHQQ1k13p",
};
exports.TermsAndConditionsUrl = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/terms-and-conditions-of-use",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/conditions-generales",
    [locales_1.Locales.ES]: "https://support.zeffy.com/terms-and-conditions-of-use",
    // TODO: i18n German terms page — the DE article awaits professional translation review.
    [locales_1.Locales.DE]: "https://support.zeffy.com/terms-and-conditions-of-use",
};
const ID_VERIFICATION_HELP_CENTER_LINK = {
    [locales_1.Locales.EN]: "https://support.zeffy.com/id-verification-requirements-setup-and-troubleshooting-zybht",
    [locales_1.Locales.FR]: "https://support.zeffy.com/fr-ca/id-verification-requirements-setup-and-troubleshooting-zybht",
    [locales_1.Locales.ES]: "https://support.zeffy.com/id-verification-requirements-setup-and-troubleshooting-zybht",
    [locales_1.Locales.DE]: "https://support.zeffy.com/de/identitatsuberprufung-anforderungen-einrichtung-und-fehlerbehebung-zybht",
};
const HELP_CENTER_LINK_US = "https://support.zeffy.com/a-guide-to-completing-your-stripe-verification-us";
const HELP_CENTER_LINK_CA_EN = "https://support.zeffy.com/complete-your-canadian-stripe-verification-l38fo";
const HELP_CENTER_LINK_CA_FR = "https://support.zeffy.com/fr-ca/un-guide-pour-compl%C3%A9ter-votre-v%C3%A9rification-stripe-au-canada";
const HELP_CENTER_LINK_AU = "https://support.zeffy.com/australian-stripe-verification-pe1xn";
const HELP_CENTER_LINK_UK = "https://support.zeffy.com/complete-your-uk-stripe-verification-soc2y";
const HELP_CENTER_LINK_DE = "https://support.zeffy.com/de/uberprufung-des-deutschen-stripe-kontos-72s5q";
const helpCenterLinkForCountry = (country, locale) => {
    if (country === country_1.OrganizationCountry.Australia) {
        return HELP_CENTER_LINK_AU;
    }
    if (country === country_1.OrganizationCountry.Canada) {
        return locale === locales_1.Locales.FR ? HELP_CENTER_LINK_CA_FR : HELP_CENTER_LINK_CA_EN;
    }
    if (country === country_1.OrganizationCountry.Germany) {
        return HELP_CENTER_LINK_DE;
    }
    if (country === country_1.OrganizationCountry.GreatBritain || country === country_1.OrganizationCountry.Ireland) {
        return HELP_CENTER_LINK_UK;
    }
    return HELP_CENTER_LINK_US;
};
exports.helpCenterLinkForCountry = helpCenterLinkForCountry;
const getVerificationHelpArticleUrl = (helpArticle, country, locale) => helpArticle === "id_verification"
    ? ID_VERIFICATION_HELP_CENTER_LINK[locale]
    : (0, exports.helpCenterLinkForCountry)(country, locale);
exports.getVerificationHelpArticleUrl = getVerificationHelpArticleUrl;
const ZEFFY_MARKETING_BASE_URL_EN = "https://www.zeffy.com";
const ZEFFY_MARKETING_BASE_URL_FR = "https://fr.zeffy.com";
const getZeffyMarketingBaseUrl = (locale) => {
    return locale === locales_1.Locales.FR ? ZEFFY_MARKETING_BASE_URL_FR : ZEFFY_MARKETING_BASE_URL_EN;
};
exports.getZeffyMarketingBaseUrl = getZeffyMarketingBaseUrl;
const getZeffyContactLink = (locale) => {
    return `${(0, exports.getZeffyMarketingBaseUrl)(locale)}/home/contact`;
};
exports.getZeffyContactLink = getZeffyContactLink;
const getZeffyDemoLink = (locale) => {
    return `${(0, exports.getZeffyMarketingBaseUrl)(locale)}/home/demo`;
};
exports.getZeffyDemoLink = getZeffyDemoLink;
const getZeffyDonateToNonprofitsLink = (locale) => {
    return `${(0, exports.getZeffyMarketingBaseUrl)(locale)}/home/donate?Donation`;
};
exports.getZeffyDonateToNonprofitsLink = getZeffyDonateToNonprofitsLink;
exports.ZeffyLandingPageUrl = {
    [locales_1.Locales.EN]: "https://www.zeffy.com/",
    [locales_1.Locales.DE]: "https://www.zeffy.com/",
    [locales_1.Locales.ES]: "https://www.zeffy.com/",
    [locales_1.Locales.FR]: "https://fr.zeffy.com/",
};
